/**
 * A simple GraphQL client for making POST requests to a GraphQL endpoint with custom headers.
 */
class GraphQLClient {
	/**
	 * Constructor for the GraphQLClient.
	 * @param {string} baseURL The base URL of the GraphQL endpoint.
	 * @param {{ [key: string]: string }} headers Optional headers to include in the request.
	 */
	constructor(baseURL, headers = {}) {
		this.baseURL = baseURL;
		this.headers = headers;
	}

	/**
	 * Makes a POST request to the GraphQL endpoint with the provided query.
	 * @param {string} query The GraphQL query to be executed.
	 * @returns {Response|null} The response from the GraphQL endpoint, or null if an error occurs.
	 */
	async postQuery(query) {
		if (!query) return null;

		try {
			const response = await fetch(this.baseURL, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					...this.headers,
				},
				body: JSON.stringify({
					query,
				}),
			}).then(res => res.json());

			return response;
		} catch (e) {
			console.error('GraphQLClient postQuery error:', e);
			return null;
		}
	}
}

export default GraphQLClient;
